'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

/**
 * Common drag and drop DataTransfer formats.
 *
 * https://web.dev/datatransfer/
 * https://developer.mozilla.org/en-US/docs/Web/API/HTML_Drag_and_Drop_API/Recommended_drag_types
 */ exports.DragAndDropFormats = void 0;
(function(DragAndDropFormats) {
    DragAndDropFormats["TextHtml"] = 'text/html';
    DragAndDropFormats["TextPlain"] = 'text/plain';
    DragAndDropFormats["TextUriList"] = 'text/uri-list';
})(exports.DragAndDropFormats || (exports.DragAndDropFormats = {}));
//# sourceMappingURL=drag-and-drop.js.map
